import React, { useState, useEffect } from "react";
import "../Style.css";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { getTemplates, deleteTemplate } from "../services/templateService";
import { useNavigate, Link } from "react-router-dom";
import { fetchBusinessList } from "../services/apiService";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { getUserInfo } from "../utils/auth";

export default function TemplateList() {
  const navigate = useNavigate();

  const [templates, setTemplates] = useState([]);
  const [clients, setClients] = useState([{}]);
  const [clientId, setClientId] = useState("");
  const [role, setRole] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const loadTemplates = async () => {
    const res = await getTemplates();
    setTemplates(res.data);
  };

  const handleDelete = async (id) => {
    await deleteTemplate(id);
    loadTemplates();
  };

  const onEdit = (id) => {
    navigate("/editTemplate/" + id);
  };

  const loadData = async () => {
    const result = await fetchBusinessList("api/v1/list");

    if (result.success) {
      if (result.data.length > 0) {
        setClientId(result.data[0]?.id);
        let clientList = [];
        result.data.map((item) => {
          let clientId = item.id;
          let clientName = item.websiteName;
          clientList.push({
            id: clientId,
            name: clientName,
          });
        });

        setClients(clientList);
      }
    } else if (!result.success) {
      toast.error(result.message);
    }
  };

  const getClientSelectedValue = (event) => {
    if (event.target.value != "") {
      setClientId(event.target.value);
    }
  };

  const setUserDetails = () => {
    const userInfo = getUserInfo();
    const ENCRYPT_DECRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
    const bytes = CryptoJS.AES.decrypt(userInfo, ENCRYPT_DECRYPTION_KEY);
    const decryptedUserDetails = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    setRole(decryptedUserDetails.role);
    setUserEmail(decryptedUserDetails.email);
  };

  useEffect(() => {
    loadTemplates();
    loadData();
    setUserDetails();
  }, [clientId]);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div>
              <div className="row col-md-12" style={{ padding: "20px" }}>
                <div className="row col-md-9">
                  <h4>Your Website With Content</h4>
                </div>

                {role == "ROLE_USER" ? (
                  <div className="row col-md-3">Website Preview</div>
                ) : (
                  <div className="row col-md-6">
                    <Link
                      to="/createTemplate"
                      className="btn btn-info mb-2"
                      style={{ float: "left", width: "200px" }}
                    >
                      Create New Template
                    </Link>
                    <br />
                    <br />
                    <select
                      className="form-control"
                      value={clientId}
                      onChange={getClientSelectedValue}
                      style={{ float: "right" }}
                    >
                      <option value="">--Select Client--</option>
                      {clients.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              <br />
              <br />
              <div className="row">
                {templates.map((tpl) => (
                  <div className="card mt-5 p-3" key={tpl.id}>
                    <h5>{tpl.name}</h5>
                    <p>{tpl.category}</p>

                    {role == "ROLE_USER" ? (
                      <div>
                        <a
                          href={`${tpl.previewUrl}/${clientId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-info me-2"
                        >
                          Live Preview
                        </a>
                      </div>
                    ) : (
                      <div>
                        <a
                          href={`${tpl.previewUrl}/${clientId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-info me-2"
                        >
                          Live Preview
                        </a>
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={(e) => onEdit(tpl.id)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(tpl.id)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                    <br />
                    <br />
                    <div className="mt-2">
                      <embed
                        src={`${tpl.previewUrl}/${clientId}`}
                        className="responsive-embed"
                        onerror="alert('URL invalid !!');"
                      />
                    </div>
                    <div style={{ margin: "50px" }}>
                      <hr />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
}
